import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getFilteredItems, getAndCheckIfAllPass, getCheckIfAnyOnePass } from 'common/utilities/utils';
import HEADER_CONSTANT from '../../HeaderConstants/HeaderConstant';
import { ROUTE_URL } from 'common/constants/SharedConstants';
import { hideAddtoCartToadAction } from '@kfc-global/react-shared/redux/Actions/CartAction';

const getCartCount = (cartCount, classNames) =>
  cartCount > 99 ? (
    <span className={`${classNames} cart-icon-plus`}>
      <span className='margin-auto'>
        99<span className='cart-plus'>+</span>
      </span>
    </span>
  ) : (
    <span className={classNames}>
      <span className='margin-auto'>{cartCount}</span>
    </span>
  );

const getCartIcon = (index, clickHandler, item, cartCount, animatedIcon) => {
  return (
    <>
      <div
        className={`shopping-cart ${animatedIcon ? 'active' : ''}`}
        onClick={() => clickHandler(HEADER_CONSTANT.CART, ROUTE_URL.CART)}
        data-testid={animatedIcon ? 'animated-icon' : 'normal-icon'}
        name={HEADER_CONSTANT.CART}
      >
        <div className='lines'>
          <span className='line first'></span>
          <span className='line second'></span>
          <span className='line third'></span>
        </div>
        <a className={`basket ${cartCount > 0 ? '' : 'blank'}`} style={{ background: `url(${item?.url}) no-repeat` }}>
          {cartCount}
        </a>
      </div>
    </>
  );
};

export const CartIconComp = props => {
  const { navRight, gotoCart } = props;
  const [showCartIcon120Percent, setShowCartIcon120Percent] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const { CART_ICON_100_PERCENT, CART_ICON_120_PERCENT } = HEADER_CONSTANT;
  const dispatch = useDispatch();

  const cartReducer = useSelector(state => state?.cartReducer);
  const tenantReducer = useSelector(state => state?.tenantReducer);
  const { addHope, carryBag } = tenantReducer;
  const {
    cartData = {},
    isItemAdded = false,
    isUpdateQuantityLoading = false,
    isRemoveItemLoading = false,
  } = cartReducer;
  const { foodLines = [] } = cartData ?? {};

  useEffect(() => {
    let timer;
    if (
      foodLines?.filter?.(foodItems => foodItems?.item?.isHidden)?.length === 0 &&
      getCheckIfAnyOnePass(isItemAdded, isUpdateQuantityLoading, isRemoveItemLoading)
    ) {
      dispatch(hideAddtoCartToadAction());
      setShowCartIcon120Percent(true);
    }
    if (showCartIcon120Percent) {
      timer = setTimeout(() => {
        setShowCartIcon120Percent(false);
      }, 600);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [
    isItemAdded,
    isUpdateQuantityLoading,
    cartReducer,
    foodLines,
    isRemoveItemLoading,
    dispatch,
    showCartIcon120Percent,
  ]);

  useEffect(() => {
    if (addHope && carryBag) {
      const filteredFoodLineData = getFilteredItems(foodLines, addHope, carryBag);
      setCartCount(_.reduce(filteredFoodLineData, (s, n) => s + n.quantity, 0));
    }
  }, [foodLines, addHope, carryBag]);

  return (
    <div className='cart-image' data-testid='cart-image'>
      {navRight?.length
        ? navRight?.map((item, index) => {
            if (getAndCheckIfAllPass(item?.url, CART_ICON_100_PERCENT === item?.title, !showCartIcon120Percent)) {
              return getCartIcon(index, gotoCart, item, cartCount, false);
            } else if (getAndCheckIfAllPass(item?.url, CART_ICON_120_PERCENT === item?.title, showCartIcon120Percent)) {
              return getCartIcon(index, gotoCart, item, cartCount, true);
            } else {
              return null;
            }
          })
        : null}
    </div>
  );
};
